/* eslint-disable no-template-curly-in-string */

import React from 'react';
import { Field } from 'redux-form';
import { BooleanInput, LongTextInput } from 'react-admin';

import CodeMirrorInput from '../../../../Common/Utils/CodeMirrorInput';

type Props = {
  item: string
};

const CreativeSettingsDetails = (props: Props) => (
  <div style={{ paddingTop: 20 }}>
    <Field name={`${props.item}.render_in_iframe`} source={`${props.item}.render_in_iframe`} component={BooleanInput} label="Render In Iframe" style={{ width: '160px' }} />
    <Field name={`${props.item}.image_title`} source={`${props.item}.image_title`} component={LongTextInput} label="Image Title" /><br />
    <Field name={`${props.item}.url`} source={`${props.item}.url`} component={LongTextInput} label="Link URL" /><br />

    <Field name={`${props.item}.trackers`} component={CodeMirrorInput} label="Trackers" mode="text/html" /><br />
    <span>Macros: {"${CACHEBUSTER}"}</span>
  </div>
);

export default CreativeSettingsDetails;



// WEBPACK FOOTER //
// ./src/views/Components/Campaigns/Site/Partials/CreativeSettingsDetails.tsx